import { useEffect, useState } from "react";
import { getDynamicDropdownByCategory } from "../../views/Admin/DynamicDropdowns/manageDynamicDropdowns";
import { DropdownOptions } from "../FormFields/DropdownField";
import Loading from "../Loading/Loading";
import MultiDropdown, { MultiDropdownProps } from "./MultiDropdown";

interface DynamicMultiDropdownFieldProps
  extends Omit<MultiDropdownProps, "options" | "selectedValues" | "onChange"> {
  category: string;
  value?: number[];
  onChange: (values: number[]) => void;
}

const DynamicMultiDropdownField = ({
  category,
  value = [],
  onChange,
  ...rest
}: DynamicMultiDropdownFieldProps) => {
  const [options, setOptions] = useState<DropdownOptions[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!category) return;
    setLoading(true);
    getDynamicDropdownByCategory(category)
      .then((res) => {
        if (res.status === 200) {
          const dropdowns: DropdownOptions[] = res.data.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setOptions(dropdowns);
        }
      })
      .finally(() => setLoading(false));
  }, [category]);

  if (loading) return <Loading showLogo={false} fullScreen={false} />;

  const selectedValues = value.flatMap((val) => {
    const match = options.find((opt) => opt.value === val);
    return match ? [match] : [];
  });

  return (
    <MultiDropdown
      options={options}
      selectedValues={selectedValues}
      onChange={(list) => onChange(list.map((item) => Number(item.value)))}
      {...rest}
    />
  );
};

export default DynamicMultiDropdownField;
